import React, { Component } from 'react';
import { ScrollView } from 'react-native';
import PropTypes from 'prop-types';
import RadioButton from '../RadioButton';
import { withTheme } from '../../theme';
class RadioButtonField extends Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = value => () => this.props.onChange(value);
    }
    render() {
        const { options, color, value, size, theme } = this.props;
        return (<ScrollView>
        {options.map(item => (<RadioButton key={item.value} smartKey={item.smartKey} label={item.label} description={item.description} value={item.value === value} disabled={item.disabled} color={color ? color : theme.tintPrimary} size={size} onChange={this.handleOnChange(item.value)}/>))}
      </ScrollView>);
    }
}
RadioButtonField.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        description: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        disabled: PropTypes.bool,
    })).isRequired,
    onChange: PropTypes.func,
    value: PropTypes.any,
    color: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium']),
    theme: PropTypes.object,
};
RadioButtonField.defaultProps = {
    size: 'medium',
};
export default withTheme(RadioButtonField);
